import { type CookieManager } from '@carvana/core-auth';
import type { CookieClient } from '../types';

export default function cookieClientToCoreCookieStore(
  cookieClient: CookieClient
): CookieManager['cookieStore'] {
  return {
    get: (name: string) => {
      const value = cookieClient.get(name);

      return value == null ? undefined : { name, value };
    },
    set(
      name: string,
      value: string,
      options?: Record<string, string | number>
    ) {
      cookieClient.set(name, value, options);
    }
  };
}
